import { PageTitle } from '../../_metronic/layout/core'
import { PartnerMappingRulesAdmin } from '../../_metronic/partials/widgets/debugging/lead-tables/PartnerMappingRulesAdmin'

const PartnerMappingRulesPage = () => (
  <>
    <PageTitle breadcrumbs={[
      { title: 'Debugging', path: '/debugging/all-leads', isSeparator: false, isActive: false },
      { title: 'Partner Mapping Rules', path: '/debugging/partner-mapping-rules', isSeparator: false, isActive: true }
    ]}>Partner Mapping Rules</PageTitle>
    <PartnerMappingRulesAdmin />
  </>
)

export { PartnerMappingRulesPage }